import { COMPANY, IMG } from "../data";

export default function About() {
  return (
    <main data-testid="about-page" style={{ background: "var(--cream)" }}>
      {/* HERO */}
      <section className="pt-40 pb-20 relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url(${IMG.founderBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        ></div>
        <div className="container-cu relative z-10 max-w-3xl">
          <p className="eyebrow mb-6">About</p>
          <h1 className="heading-display text-5xl sm:text-6xl lg:text-7xl mb-6">
            About <br />
            <span className="heading-italic">Casa Haya International</span>
          </h1>
          <p className="text-lg leading-relaxed" style={{ color: "var(--brown-soft)" }}>
            One holding. One founder. A handful of brands and a single house in
            the mountains — all built with intention.
          </p>
        </div>
      </section>

      {/* HOLDING STORY */}
      <section className="section">
        <div className="container-cu grid lg:grid-cols-12 gap-14">
          <div className="lg:col-span-5">
            <p className="eyebrow mb-5">The Holding</p>
            <h2 className="heading-display text-4xl sm:text-5xl">
              Built like a <span className="heading-italic">home</span>, not a hierarchy.
            </h2>
          </div>
          <div className="lg:col-span-7 space-y-5 text-base leading-relaxed" style={{ color: "var(--brown-soft)" }}>
            <p>
              {COMPANY.name} is the operational company behind three AI-native
              digital brands and a luxury short-stay home in the heart of
              Northern Spain.
            </p>
            <p>
              There is no team and no office. There is a founder, a deep belief
              in technology that serves people, and an obsession with the
              feeling of a place that welcomes you in.
            </p>
            <p>
              Everything we build — Zynthoro for ambitious businesses, GojiDiva
              for the LGBTQ+ community, My Rootzz for those who want to be
              remembered, and Casa Haya for those who want to rest — is
              built around one quiet principle: it should feel like home.
            </p>
          </div>
        </div>
      </section>

      {/* FOUNDER */}
      <section className="section" style={{ background: "var(--brown)" }}>
        <div className="container-cu grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div
              className="aspect-[4/5] rounded-md relative overflow-hidden flex flex-col items-center justify-center p-12 text-center"
              style={{
                background: "linear-gradient(160deg, #C9A84C 0%, #a88a35 100%)",
              }}
            >
              <i
                className="fa-solid fa-quote-right text-5xl mb-6"
                style={{ color: "var(--brown)", opacity: 0.4 }}
              ></i>
              <p
                className="heading-display heading-italic text-3xl sm:text-4xl"
                style={{ color: "var(--brown)" }}
              >
                My different is my normal.
              </p>
              <p className="mt-6 text-xs uppercase tracking-[0.3em]" style={{ color: "var(--brown-soft)" }}>
                Ramona
              </p>
            </div>
          </div>
          <div className="lg:col-span-7">
            <p className="eyebrow eyebrow-light mb-5" style={{ color: "var(--gold-soft)" }}>
              The Founder
            </p>
            <h2 className="heading-display text-4xl sm:text-5xl mb-8" style={{ color: "var(--cream)" }}>
              <span className="heading-italic" style={{ color: "var(--gold)" }}>Ramona</span>
            </h2>
            <div className="space-y-5 text-base leading-relaxed" style={{ color: "rgba(250,247,242,0.85)" }}>
              <p>
                Entrepreneur, mother of three, married to a wonderful man since
                2008, and a firm believer in building things that last.
              </p>
              <p>
                Operating from Northern Spain with Dutch roots, Ramona builds
                technology and spaces that serve people with warmth, intention
                and purpose.
              </p>
              <p className="font-serif italic text-xl" style={{ color: "var(--gold-soft)" }}>
                No team. No office. No excuses.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="section" style={{ background: "var(--cream-deep)" }}>
        <div className="container-narrow text-center">
          <p className="eyebrow mb-5">Our Mission</p>
          <h2 className="heading-display text-3xl sm:text-5xl leading-tight">
            We build spaces and platforms that serve people — with{" "}
            <span className="heading-italic">warmth</span>,{" "}
            <span className="heading-italic">intention</span> and{" "}
            <span className="heading-italic">purpose</span>.
          </h2>
        </div>
      </section>

      {/* COMPANY DETAILS */}
      <section className="section">
        <div className="container-cu">
          <p className="eyebrow mb-10 text-center">Company Details</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
            {[
              { l: "Company", v: COMPANY.name },
              { l: "KvK", v: COMPANY.kvk },
              { l: "BTW", v: COMPANY.btw },
              { l: "Address", v: COMPANY.address },
              { l: "Email", v: COMPANY.email, link: `mailto:${COMPANY.email}` },
              { l: "Founder", v: COMPANY.founder },
              { l: "Operating from", v: "Northern Spain · Dutch roots" },
            ].map((d) => (
              <div
                key={d.l}
                className="p-6 rounded-md"
                style={{
                  background: "var(--white)",
                  border: "1px solid var(--line)",
                }}
              >
                <p className="eyebrow mb-3">{d.l}</p>
                {d.link ? (
                  <a href={d.link} className="font-serif text-lg link-underline" style={{ color: "var(--forest)" }}>
                    {d.v}
                  </a>
                ) : (
                  <p className="font-serif text-lg" style={{ color: "var(--forest)" }}>
                    {d.v}
                  </p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
